import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { postCustomSalesTax } from "../../../api/OrderSummaryApi";

function useCustomSalesTaxSelector(quoteId: string, isFetching: boolean) {
  const queryClient = useQueryClient();

  const [customTax, setCustomTax] = useState<null | string>(null);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleCustomTax = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    const withDecimal = value.includes(".");

    if (withDecimal) {
      const decimalPlaces = value.split(".")[1].length;
      if (decimalPlaces > 3) return;
    } else {
      if (value.length > 2) return;
    }

    setCustomTax(value);
  };

  const changeSalesTax = async () => {
    if (!customTax || isFetching) return;

    const salesTax = parseFloat(customTax) / 100;
    const response = await postCustomSalesTax(salesTax, quoteId);

    if (response.data === "Sales Tax Changed") {
      queryClient.invalidateQueries("Cart");
      handleClose();
    }
  };

  return {
    changeSalesTax,
    handleCustomTax,
    handleOpen,
    open,
    customTax,
    handleClose
  };
}

export default useCustomSalesTaxSelector;
